import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet (404) | Tømrerfirmaet RNS</title>
        <meta name="robots" content="noindex, nofollow" />
        <html lang="da-DK" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-slate-50 py-20 px-6">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-10 rounded-2xl border border-slate-100 shadow-sm">
          <div className="w-20 h-20 rounded-full bg-rose-50 text-rose-500 flex items-center justify-center text-4xl mx-auto">
            <i className="fa-solid fa-triangle-exclamation" />
          </div>
          <div className="space-y-2">
            <h1 className="font-display font-extrabold text-3xl text-slate-900">
              Siden blev ikke fundet
            </h1>
            <p className="text-slate-500 text-sm leading-relaxed">
              Beklager, men den side du leder efter findes ikke eller er blevet flyttet.
            </p>
          </div>
          <div className="pt-4 flex flex-col gap-3">
            <Link
              to="/"
              className="bg-brand-primary hover:bg-brand-primary/90 text-white font-semibold py-3 px-6 rounded-none transition-all shadow-sm flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house" />
              Gå til forsiden
            </Link>
            <Link
              to="/ydelser"
              className="bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200 font-semibold py-3 px-6 rounded-none transition-all flex items-center justify-center gap-2"
            >
              Se vores ydelser
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
